import React from 'react'
import { FiCheck, FiLoader } from 'react-icons/fi'

export default function Checkbox({ checked, onClick, className, loading, variant = 'default' }) {
  const size = variant === 'small' ? 'w-6 h-6' : 'w-8 h-8'
  return (
    <div
      onClick={!loading && onClick}
      className={`flex justify-center text-black bg-transparent items-center flex-shrink-0 ${size} border-2 rounded border-black cursor-pointer ${className}`}>
      {loading && <FiLoader className="h-8 w-8 stroke-1 rotating box-border" />}
      {!loading && checked && <FiCheck className={`stroke-2 ${size}`} />}
    </div>
  )
}
